import { render, staticRenderFns } from "./UserHistoryPage.vue?vue&type=template&id=2a1eae38"
import script from "./UserHistoryPage.vue?vue&type=script&lang=js"
export * from "./UserHistoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports